module.exports = __webpack_public_path__ + "img/logo_sdv.f8052b15.png";